// extracted by mini-css-extract-plugin
module.exports = {"InformationPage":"InformationPage_InformationPage__2QmJq"};